import React from 'react';

import { useRoutes } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider } from '@mui/material';

import themes from './themes';
import NavigationScroll from './layout/NavigationScroll';

import {
    LAYOUT_MAIN,
    LAYOUT_MINIMAL,
    LAYOUT_BODEGA,
    LAYOUT_VITICULTOR
} from 'core/constants';
import MainLayout from './layout/MainLayout';
import MinimalLayout from './layout/MinimalLayout';
import BodegaLayout from './layout/BodegaLayout';
import ViticultorLayout from './layout/ViticultorLayout';

import config from '../../config';

export const TemplateBerry = props => {
    const { routes, customization } = props;

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <NavigationScroll>
                    {useRoutes(routes, config.basename)}
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export const layouts = navigation => {
    return {
        [LAYOUT_MAIN]: <MainLayout navigation={navigation} />,
        [LAYOUT_MINIMAL]: <MinimalLayout />,
        [LAYOUT_BODEGA]: <BodegaLayout navigation={navigation} />,
        [LAYOUT_VITICULTOR]: <ViticultorLayout navigation={navigation} />
    };
};
